import BookingAppointmentTypeHtml from './booking.appointment-type.html';

export function BookingsSettingsCtrl (
  $scope,
  $state,
  $translate,
  $uibModal,
  appointmentTypes,
  integrations,
  maskedCompanyId,
  messages,
  sessionObjAPI,
  settings,
  tableApi,
  workshopAPI
) {

  $scope.appointmentTypes = appointmentTypes;
  $scope.company          = sessionObjAPI.company();
  $scope.integrations     = integrations;
  $scope.loaded           = true;
  $scope.publicUrl        = `${sessionObjAPI.base().origin}bookings.html#/${settings.public_booking_diary_company_url}?token=${settings.public_booking_diary_token}`;
  $scope.settings         = settings;
  $scope.tableCacheKey    = 'bookingAppointmentTypes';

  $scope.settings.masked_company_id                    = maskedCompanyId;
  $scope.settings.public_booking_diary_header_color    = $scope.settings.public_booking_diary_header_color    || '#1F6183';
  $scope.settings.public_booking_diary_subheader_color = $scope.settings.public_booking_diary_subheader_color || '#1F6183';

  $scope.logoOptions = {
    accept: 'images',
    file  : $scope.settings.public_booking_diary_logo,
    size  : 200000,
    type  : 'pbd_logo'
  };

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'description',
        header: {
          text: 'Description'
        }
      },
      {
        field : 'estimated_hours',
        header: {
          text: 'Estimated Hours'
        }
      }
    ],
    empty: {
      text: 'No Appointment Types'
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 20, 50],
      queryCount: () => workshopAPI.get('/appointment_types/count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.createAppointmentType = function () {
    $uibModal.open({
      templateUrl: BookingAppointmentTypeHtml,
      windowClass: 'lg-modal',
      resolve    : {
        appointmentType: function () {
          return {};
        }
      },
      controller: 'BookingAppointmentTypeCtrl'
    }).result.then(function (data) {
      $state.reload();
      messages.show(data, 'success');
    });
  };

  $scope.addAllAppointmentsToVVGarage = function () {
    workshopAPI.post('/vv_garage/add_appointment_types_to_vv_garage').then(() => {
      messages.show('Appointments Added to VV Garage', 'success');
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.getAppointmentTypes = ( params ) => {
    return workshopAPI.get('/appointment_types', [
      params.offset,
      params.pageSize
    ]).then(appointmentTypes => {
      $scope.appointmentTypes = appointmentTypes;

      return appointmentTypes;
    });
  };

  $scope.refresh = function () {
    $state.reload();
    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED') , 'success');
  };

  $scope.save = function () {
    workshopAPI.patch('/company_settings', $scope.settings, 'company_setting')
      .then(function () {
        messages.show('Settings Saved', 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.select = function(event) {
    $uibModal.open({
      templateUrl: BookingAppointmentTypeHtml,
      windowClass: 'lg-modal',
      resolve    : {
        appointmentType: function () {
          return workshopAPI.get('/appointment_type', event.row.id);
        }
      },
      controller: 'BookingAppointmentTypeCtrl'
    }).result.then(function (data) {
      $state.reload();
      messages.show(data, 'success');
    });
  };

  $scope.isBoschPuppet = function() {
    if (sessionObjAPI.base().puppet_session && sessionObjAPI.company().branding_group == 'bosch') {
      return true;
    }
    else {
      return false;
    };
  };
}
